export default "__VITE_ASSET__jlxUMPim__$_?url__"